import { MtpStatus } from '~/utils/interfaces';
import { safeInvertedDifference } from '~/utils/math-helper';
import { GetMiniFdByGlobalIdResponse } from '~/models/services/minifd';

/**
 * First-year (MTP+1) compensation gap from planning vs required — same formula as `view-cost-table`
 * “Compensation required” cell for MTP+1 (in table currency units, not EUR).
 */
export function computeViewCompensationGapMtpPlus1(iybr: GetMiniFdByGlobalIdResponse | null | undefined): number {
    if (!iybr?.budgetRequests?.length) {
        return 0;
    }

    const sumBudgetRequestPlanningField = (field: string): number => {
        const approved = iybr.budgetRequests
            .filter(budgetRequest => budgetRequest.planning?.mtpStatus === MtpStatus.APPROVED)
            .map(budgetRequest => budgetRequest.planning[field])
            .reduce((previous, current) => previous + current, 0);

        const pending = iybr.budgetRequests
            .filter(budgetRequest => budgetRequest.planning && budgetRequest.planning?.mtpStatus !== MtpStatus.APPROVED)
            .map(budgetRequest => budgetRequest.planning[field])
            .reduce((previous, current) => previous + current, 0);

        return approved + pending;
    };

    const budgetInMtpMtpPlus1 = sumBudgetRequestPlanningField('new1');
    const budgetRequiredMtpPlus1 = iybr.spentYearPlus1 ?? 0;

    return safeInvertedDifference(budgetInMtpMtpPlus1, budgetRequiredMtpPlus1);
}
